import { OptionsBox } from '@quizzach/styles';
import { useWindowListener } from '@quizzach/contexts';

export const PaymentCardOptions = ({
	style,
}: {
	style?: React.CSSProperties;
}) => {
	const { touchDevice } = useWindowListener();

	return (
		<OptionsBox style={style}>
			<a
				href='https://www.corvuspay.com/'
				target='_blank'
				rel='noopener noreferrer'
			>
				<img
					src={`/card-icons/payment_corvus.png`}
					alt={`corvus_logo`}
					height={touchDevice ? '13px' : '18px'}
				/>
			</a>

			<a
				href='https://www.mastercard.com'
				target='_blank'
				rel='noopener noreferrer'
			>
				<img
					src={`/card-icons/payment_mastercard.png`}
					alt={`mastercard_logo`}
					height={touchDevice ? '18px' : '28px'}
				/>
			</a>

			<a
				href='https://www.mastercard.hr/hr-hr/consumers/find-card-products/debit-cards/maestro-debit.html'
				target='_blank'
				rel='noopener noreferrer'
			>
				<img
					src={`/card-icons/payment_maestro.png`}
					alt={`maestro_logo`}
					height={touchDevice ? '18px' : '28px'}
				/>
			</a>
			<a
				href='https://www.mastercard.hr/hr-hr/issuers/identity-check.html'
				target='_blank'
				rel='noopener noreferrer'
			>
				<img
					src={`/card-icons/payment_mastercardID.png`}
					alt={`mastercardID_logo`}
					height={touchDevice ? '21px' : '28px'}
				/>
			</a>

			<a
				href='https://www.visa.com.hr'
				target='_blank'
				rel='noopener noreferrer'
			>
				<img
					src={`/card-icons/payment_visa.png`}
					alt={`visa_logo`}
					height={touchDevice ? '13px' : '15px'}
				/>
			</a>
			<a
				href='https://www.visa.com.hr/placajte-visa-karticom/featured-technologies/verified-by-visa.html'
				target='_blank'
				rel='noopener noreferrer'
			>
				<img
					src={`/card-icons/payment_visaSecure.png`}
					alt={`visaSecure_logo`}
					height={touchDevice ? '18px' : '25px'}
				/>
			</a>
			<a href='https://www.diners.hr' target='_blank' rel='noopener noreferrer'>
				<img
					src={`/card-icons/payment_diners.png`}
					alt={`diners_logo`}
					height={touchDevice ? '18px' : '25px'}
				/>
			</a>
		</OptionsBox>
	);
};
